import script from "./single-video.vue?vue&type=script&lang=ts&setup=true"
export * from "./single-video.vue?vue&type=script&lang=ts&setup=true"

import "./single-video.vue?vue&type=style&index=0&id=ac89a526&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac89a526"]])

export default __exports__